<template>
	<div class="ReDoska">
		<template v-if="masTasks.length>0">
			<div class="col-sm-12 col-md-6 col-lg expired">
				<div class="colHeader" @click="showExpiredTasks()"><i class="tim-icons icon-tap-02"></i>Просрочено</div>

				<div class="task" :class="[expiredIsShown ? 'task-shown' : 'task-hidden']">
					<template v-for="task in masTasks">				
						<ReCardTask v-if="task.overdue == '1' && task.STATUS != 'Готово'  && task.STATUS != 'В архиве'" :key="task.id" :objTask="$GVO.unlinkObject(task)" class="taskStatus px-0 col-sm-12 "/>
					</template>
					<button v-if="bShowOverdue" class="btn btn-simple btn-success w-100" @click="LoadMore('overdue')">Загрузить ещё</button>
				</div>

			</div>
			<div class="col-sm-12 col-md-6 col-lg current">
				<div class="colHeader" @click="showCurrentTasks()"><i class="tim-icons icon-tap-02"></i>Задачи на сегодня</div>

				<div class="task" :class="[currentIsShown ? 'task-shown' : 'task-hidden']">
					<template v-for="task in masTasks">				
						<ReCardTask v-if="task.overdue == '0' && task.STATUS != 'Готово' && isTodayTask(task)" :key="task.id" :objTask="$GVO.unlinkObject(task)" class="taskStatus px-0 col-sm-12 "/>
					</template>
					<button v-if="bShowCurrent" class="btn btn-simple btn-success w-100" @click="LoadMore('current')">Загрузить ещё</button>
				</div>

			</div>
			<div class="col-sm-12 col-md-6 col-lg tomorrow">
				<div class="colHeader" @click="showTomorrowTasks()"><i class="tim-icons icon-tap-02"></i>Задачи на будущее</div>

				<div class="task" :class="[tomorrowIsShown ? 'task-shown' : 'task-hidden']">
					<template v-for="task in masTasks">				
						<ReCardTask v-if="task.overdue == '0' && task.STATUS != 'Готово' && isTomorrowTask(task)" :key="task.id" :objTask="$GVO.unlinkObject(task)" class="taskStatus px-0 col-sm-12 "/>
					</template>
					<button v-if="bShowNext" class="btn btn-simple btn-success w-100" @click="LoadMore('next')">Загрузить ещё</button>
				</div>

			</div>
		</template>
		<template v-else>
			<h3>Задач не найдено</h3>
		</template>
	</div>
</template>

<script>
import ReCardTask from "src/our_components/ReCardTask.vue";	
import moment from 'moment';
import VueMoment from 'vue-moment';

	export default {
		name: 'ReDoska',
		components: {
			ReCardTask,			
		},
		props: {
			masTasks: {
				type: Array,
				default(){return []},
			},
			bShowOverdue:{
				type: Boolean,
				default: true
			},
			bShowCurrent:{
				type: Boolean,
				default: true
			},
			bShowNext:{
				type: Boolean,
				default: true
			},
			
		},
		data () {
			return {
				ver: 1,
				expiredIsShown: true,
				currentIsShown: true,
				tomorrowIsShown: true,
				
			}
		},
		computed: {			

		},
		methods: {
			LoadMore(strType){
				this.$emit('loadmore', strType);
			},
			showExpiredTasks() {
			this.expiredIsShown = !this.expiredIsShown;
			},
			showCurrentTasks() {
			this.currentIsShown = !this.currentIsShown;
			},
			showTomorrowTasks() {
			this.tomorrowIsShown = !this.tomorrowIsShown;
			},
			isTodayTask(task){
				if(typeof task != 'undefined'){
					return moment().isSameOrAfter(task.STARTDATE,'day');
				}
				return false;
			},
			isTomorrowTask(task){
				if(typeof task != 'undefined'){
					return moment().isBefore(task.STARTDATE,'day');
				}
				return false;
			}
		},
	}
</script>
<style scoped>
.ReDoska {display: flex; flex-wrap: wrap;}
.ReDoska .colHeader {
	width: 100%;
	align-items: center;
    display: flex;
    justify-content: center;
	padding: 10px;
	margin-bottom: 20px;	
	background-color: #01B0E0;
	border-radius: 4px;
	color: #fff;
	font-size: 1rem;
	cursor: pointer;
}
.ReDoska .colHeader .tim-icons {margin-right: 8px;}

.taskStatus.completed  {border: 1px solid #00BF9A;}
.taskStatus.current  {border: 1px solid #01B0E0;}
.taskStatus.expired  {border: 1px solid #F84E54;}
.taskStatus.event  {border: 1px solid #FF8D72;}

.task.task-shown {display: block;}
.task.task-hidden {display: none;}

@media (max-width: 768px){
	.expired, .current, .tomorrow {
		padding: 0;
	}
}




</style>
